import React from 'react';

import { View } from 'react-native';

import FastImage from 'react-native-fast-image';

import { placeHolderDetailLandscape } from 'assets/images';

import { isTabletOrWeb, isWeb } from 'utils/responsiveness';

import BaseTileImage from 'components/BaseTileImage';
import {
    AspectRatio,
    ImageSize,
    ImageType,
    NagraImageUrlParams,
} from 'components/NagraImage/types';
import {
    PLACEHOLDER_ICON_CENTER,
    PLACEHOLDER_ICON_RIGHT,
} from 'components/Ribbon/constants';

import DetailImageGradient from '../DetailImageGradient';
import styles from './styles';

type Props = {
    contentId: string | undefined;
    contentType: NagraImageUrlParams['contentType'];
};

function DetailPageImage({ contentId = '', contentType }: Props) {
    return (
        <View style={styles.root}>
            <BaseTileImage
                style={styles.image}
                contentId={contentId}
                contentType={contentType}
                imageType={ImageType.CONTENT_IMAGE}
                aspect={AspectRatio.LANDSCAPE}
                width={ImageSize.BACKGROUND.width}
                resizeMode={FastImage.resizeMode.cover}
                placeHolder={
                    isTabletOrWeb
                        ? PLACEHOLDER_ICON_RIGHT
                        : PLACEHOLDER_ICON_CENTER
                }
                backupSource={isWeb && placeHolderDetailLandscape}
            />
            <DetailImageGradient />
        </View>
    );
}

export default DetailPageImage;
